import { useEffect, useState } from 'react'

interface CountDownOptions {
	durationSeconds: number
	redirectUrl?: string
	clearUserConsentAndCloseOrRedirect: (redirectUrl?: string) => void
}

export const useEndOfFlowCountdownAction = ({
	durationSeconds,
	redirectUrl,
	clearUserConsentAndCloseOrRedirect,
}: CountDownOptions): number => {
	const [count, setCount] = useState(durationSeconds)

	useEffect(() => {
		const interval = setInterval(() => {
			setCount((prev) => {
				if (prev === 1 || prev === 0) {
					clearInterval(interval)
					clearUserConsentAndCloseOrRedirect(redirectUrl)
					return 0
				}
				return prev - 1
			})
		}, 1000)

		return () => {
			clearInterval(interval)
		}
	}, [count, redirectUrl, clearUserConsentAndCloseOrRedirect])

	return count
}
